import Icons from "../Icons";

export const SuccessDialog = ({
  isOpen,
  setIsPreviousModalOpen,
  onClose,
  xp,
  title,
  label,
}) => {
  if (!isOpen) return null;

  return (
    <div className="font-[Afacad Flux] fixed inset-0 bg-darkblue bg-opacity-65 flex justify-center items-center">
      <div className="bg-background-blackpearl shadow-lg w-3/5 2xl:w-1/2">
        <div className="flex justify-end items-center pl-6 pr-3 pt-3 pb-4 mb-10">
          <button
            onClick={onClose}
            className="text-[#F5EFF7] text-2xl justify-end"
          >
            &times;
          </button>
        </div>
        <div className="p-6 mb-10">
          <p className="text-center text-transparent text-[36px] font-normal leading-[42px] tracking-[-0.72px] mb-4">
            <span className="text-white">you earned </span>
            <span className="bg-clip-text bg-gradient-to-r from-[#8C421D] via-[#FBE67B] to-[#D4A041]">
              {xp} XP
            </span>
          </p>
          <div className="flex justify-center mb-4">
            <Icons type="bookmarkEarned" />
            <p className="absolute mt-[107px] bg-clip-text text-transparent bg-gradient-to-r from-[#8C421D] via-[#FBE67B] to-[#D4A041] font-[Afacad Flux] text-[24px] font-semibold leading-[32px] tracking-[0.72px] uppercase">
              {xp} XP
            </p>
          </div>
          <p className="text-white mb-4 text-[24px] text-center font-normal font-light leading-[32px] tracking-[0.72px] uppercase">
            {title}
          </p>
          <p className="text-[14px] font-normal leading-[20px] lowercase text-center text-[#F4F6FB]">
            {label}
          </p>
        </div>
        {title !== "task created" ? (
          <div className="flex justify-between p-6">
            <button
              type="button"
              onClick={() => {
                setIsPreviousModalOpen(true);
                onClose();
              }}
              className="bg-transparent text-persimmon font-medium py-2 px-4 rounded-full text-base leading-5 tracking-wide uppercase border border-persimmon"
            >
              CREATE ANOTHER
            </button>
            <button
              onClick={onClose}
              className="bg-persimmon hover:bg-persimmon-dark text-black font-medium py-2 px-4 rounded-full text-base leading-5 tracking-wide uppercase"
            >
              CLOSE
            </button>
          </div>
        ) : (
          <div className="flex justify-end p-6">
            <button
              type="button"
              onClick={onClose}
              className="bg-persimmon hover:bg-persimmon-dark text-black font-medium py-2 px-4 rounded-full text-base leading-5 tracking-wide uppercase"
            >
              close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
